import { Menu } from "lucide-react";
import NotificationsBell from "./NotificationsBell";
import ViewAsControl from "./ViewAsControl";

interface TopBarProps {
  title: string;
  slotRef: (el: HTMLDivElement | null) => void;
  onMenuClick: () => void;
}

export default function TopBar({ title, slotRef, onMenuClick }: TopBarProps) {
  return (
    <header className="flex h-14 items-center justify-between gap-3 border-b border-gray-200 bg-white px-4 md:px-6">
      <div className="flex min-w-0 flex-1 items-center gap-3">
        <button
          onClick={onMenuClick}
          className="rounded-lg p-1.5 text-gray-500 hover:bg-gray-100 md:hidden"
          title="Open menu"
        >
          <Menu size={20} />
        </button>
        <div ref={slotRef} className="peer flex min-w-0 flex-1 items-center empty:hidden" />
        <span className="hidden text-sm font-medium text-gray-700 peer-empty:inline">{title}</span>
      </div>
      <div className="flex shrink-0 items-center gap-2">
        <ViewAsControl />
        <NotificationsBell />
      </div>
    </header>
  );
}
